import React from 'react';

class LoadingSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isActive: false,
      hideLoadingIcon: this.props.hideLoadingIcon,
      text: this.props.text
    };
  }

  componentDidMount() {
    this.timer = setTimeout(this.enableLoading.bind(this), 250);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  enableLoading() {
    this.setState({ isActive: true });
  }

  render() {
    if (!this.state.isActive) {
      return null;
    }

    return(
      <div className="loading-section">
        <p className="copy">
          {this.state.text}
        </p>
        {!this.state.hideLoadingIcon &&
          <p className="spinner"></p>
        }
      </div>
    );
  }
}

export default LoadingSection;
